import { render } from "./Link.vue?vue&type=template&id=10bb39f4"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
script.render = render

export default script